// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1l_DM","menuItem":"Menu_menuItem__1lN1e","menuItemActive":"Menu_menuItemActive__1XDlk","menuContainer":"Menu_menuContainer__1a_FW"};